import { render, staticRenderFns } from "./ParticipantsDetails.vue?vue&type=template&id=3930f612&"
import script from "./ParticipantsDetails.vue?vue&type=script&lang=js&"
export * from "./ParticipantsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports